import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    currentBranchStock: string | undefined;
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    currentPageType: getCurrentPage(state).type,
});

interface ProductContextAvailabilityStyles {
    container: GridContainerProps;
    outOfStockText: TypographyPresentationProps;
    availability?: GridItemProps;
    availableStockText?: TypographyPresentationProps;
    availableText?: TypographyPresentationProps;
    inStockGridItem?: GridItemProps;
}
const productContextAvailabilityStyles: ProductContextAvailabilityStyles = {
    container: {
        css: css`
            margin-bottom: 10px;
        `,
    },
    outOfStockText: {
        css: css`
            padding-left: 15px;
            padding-right: 15px;
            background-color: #ca4200;
            color: white;
            font-size: 12px;
            border-radius: 5px;
            margin-right: 15px;
        `,
    },
    availability: {
        width: 12,
        css: css` margin-top: 15px !important; `,
    },
    availableStockText: {
        css: css`
            padding-left: 15px;
            padding-right: 15px;
            background-color: #3cb24d;
            color: white;
            font-size: 12px;
            border-radius: 5px;
            margin-right: 15px;
        `,
    },
    availableText: {
        css: css`
            font-size: 12px;
        `,
    },
    inStockGridItem: {
        width: 12,
    },
};

const styles = productContextAvailabilityStyles;
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const ProductInventoryStockCount = ({ currentBranchStock, currentPageType, session }: Props) => {
    if (currentPageType !== "ProductDetailsPage") {
        return null;
    }

    if (!session?.userRoles?.includes("AccountManager")) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            {currentBranchStock &&
                (currentBranchStock === "0" ? (
                    <GridItem {...styles.availability}>
                        <Typography {...styles.outOfStockText}>0</Typography>
                        <Typography {...styles.availableText}>{translate("Available in Selected Branch")}</Typography>
                    </GridItem>
                ) : (
                    <GridItem {...styles.inStockGridItem}>
                        <Typography {...styles.availableStockText}>{currentBranchStock}</Typography>
                        <Typography {...styles.availableText}>{translate("Available")}</Typography>
                    </GridItem>
                ))}
        </GridContainer>
    );
};

export default connect(mapStateToProps)(ProductInventoryStockCount);
